// extracted by mini-css-extract-plugin
module.exports = {"title":"PropertyView__title__3BawS","editor":"PropertyView__editor__1fJun"};